// IndexedDB helper for storing large images (bypasses localStorage 5MB limit)

const DB_NAME = 'ChurchImageDB';
const DB_VERSION = 1;
const STORE_NAME = 'images';

// Initialize IndexedDB
const initDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id' });
      }
    };
  });
};

// Save image to IndexedDB
export const saveImageToDB = async (id, imageData) => {
  try {
    const db = await initDB();
    const transaction = db.transaction([STORE_NAME], 'readwrite');
    const store = transaction.objectStore(STORE_NAME);
    
    await store.put({ id, data: imageData, timestamp: Date.now() });
    return true;
  } catch (error) {
    console.error('Error saving image to IndexedDB:', error);
    return false;
  }
};

// Get image from IndexedDB
export const getImageFromDB = async (id) => {
  try {
    const db = await initDB();
    const transaction = db.transaction([STORE_NAME], 'readonly');
    const store = transaction.objectStore(STORE_NAME);
    
    return new Promise((resolve, reject) => {
      const request = store.get(id);
      request.onsuccess = () => resolve(request.result?.data || null);
      request.onerror = () => reject(request.error);
    });
  } catch (error) {
    console.error('Error getting image from IndexedDB:', error);
    return null;
  }
};

// Get all images from IndexedDB
export const getAllImagesFromDB = async () => {
  try {
    const db = await initDB();
    const transaction = db.transaction([STORE_NAME], 'readonly');
    const store = transaction.objectStore(STORE_NAME);
    
    return new Promise((resolve, reject) => {
      const request = store.getAll();
      request.onsuccess = () => {
        const images = {};
        request.result.forEach(item => {
          images[item.id] = item.data;
        });
        resolve(images);
      };
      request.onerror = () => reject(request.error);
    });
  } catch (error) {
    console.error('Error getting all images from IndexedDB:', error);
    return {};
  }
};

// Delete image from IndexedDB
export const deleteImageFromDB = async (id) => {
  try {
    const db = await initDB();
    const transaction = db.transaction([STORE_NAME], 'readwrite');
    const store = transaction.objectStore(STORE_NAME);
    
    await store.delete(id);
    return true;
  } catch (error) {
    console.error('Error deleting image from IndexedDB:', error);
    return false;
  }
};

// Clear all images from IndexedDB
export const clearAllImages = async () => {
  try {
    const db = await initDB();
    const transaction = db.transaction([STORE_NAME], 'readwrite');
    const store = transaction.objectStore(STORE_NAME);
    
    await store.clear();
    return true;
  } catch (error) {
    console.error('Error clearing images from IndexedDB:', error);
    return false;
  }
};
